import { CreateMUIStyled, createStyled, KitTheme } from 'react-ui-kit-exante';

import { theme } from './theme';

export const styled: CreateMUIStyled<KitTheme> = createStyled({
  themeId: 'crm-theme',
  defaultTheme: theme,
});
